
import Hero from './components/Hero';
import Navbar from './components/Navbar';
import Problems from './components/Problems';
import Services from './components/Services';
import Process from './components/Process';
import Founder from './components/Founder';
import CTASection from './components/CTASection';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <Problems />
      <Services />
      <Process />
      <Founder />
      <CTASection />
      <Footer />
    </div>
  );
}
